<template>
  <div id="merch-page">
    <HeaderSection></HeaderSection>
    <div>
      <div id="merch-title">Merch Stores</div>
      <div id="store-picker">
        <a class="store-link" href="http://store.goodkidofficial.com"
          >World Wide</a
        >
        <a class="store-link" href="https://uk-store.goodkidofficial.com">UK</a>
      </div>
      <div id="image-container">
        <img width="300px" src="@/assets/nomu-smaller.png" />
      </div>
    </div>
    <FooterSection :layered="false" id="footer"></FooterSection>
  </div>
</template>

<script>
import HeaderSection from "@/components/HeaderSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "App",
  components: {
    HeaderSection,
    FooterSection,
  },
};
</script>

<style scoped>
@font-face {
  font-family: "blok";
  src: url("~@/assets/blok.heavy.ttf");
}

.store-link {
  display: block;
  background-color: white;
  color: #4b3e3e;
  margin: 10px 20px;
  padding: 20px;
  border-radius: 20px;
  text-decoration: none;
  border-width: 2px;
  border-style: solid;
  border-color: #c7dedb;
}
</style>

<style scoped>
#merch-title {
  padding-top: 40px;
  font-family: "blok" !important;
  color: #fff4df;
  text-shadow: 1px 2px #2b3d2e;
  font-size: 70px;
  margin-bottom: 35px;
}

#store-picker {
  margin: 0 auto;
  max-width: 500px;
}

#merch-page {
  background-image: url("@/assets/background-long.jpg");
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

#image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 40px
}

#footer {
  margin-top: auto;
}
</style>
